// extracted by mini-css-extract-plugin
module.exports = {"Pagination":"styles_Pagination__illu0","content":"styles_content__IyxbP"};